import React, { useEffect, useState } from "react";

import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Image from "../components/Image";

const images = [
  {
    source: "homepage1",
    img: "/images/homepage1.jpg",
    title: "Procena rizika od katastrofa",
    route: "/procena-rizika-od-katastrofa",
    subtitle: "Bezbednost počinje od prevencijom, a sigurnost procenom rizika",
    key: 1,
  },
  {
    source: "homepage2",
    img: "/images/homepage2.jpg",
    title: "Plan zaštite i spasavanja",
    route: "/plan-zastite-i-spasavanja",
    subtitle: "Bezbednost počinje od prevencijom, a sigurnost procenom rizika",
    key: 2,
  },
  {
    source: "homepage3",
    img: "/images/homepage3.jpg",
    title: "Plan zaštite od udesa",
    route: "/plan-zastite-od-udesa",
    subtitle: "Bezbednost počinje od prevencijom, a sigurnost procenom rizika",
    key: 3,
  },
];

const Dasboard = () => {
  const [isVertical, setVertical] = useState(true);
  useEffect(() => {
    const { innerWidth: width, innerHeight: height } = window;
    if (width > height) {
      setVertical(false);
    } else {
      setVertical(true);
    }
  }, []);
  return (
    <div>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        slidesPerView={1}
        loop
        speed={1000}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        className="swiper"
        navigation
        // pagination={{ clickable: true }}
      >
        {images.map((image) => (
          <SwiperSlide key={image.key}>
            <Image image={image} key={image.key} isVertical={isVertical} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Dasboard;
